export { default } from './ChangePassword'



// WEBPACK FOOTER //
// ./src/components/ChangePassword/index.js